import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, useSession, PricingTable } from '@clerk/react';
import Footer from '../components/Footer';
import './VerifiedPage.css';

/**
 * Access gate / pricing page.
 *
 * Reached when a signed-in user has no active plan (Dashboard redirects them
 * here). It shows only the pricing table; every other state redirects:
 *   - not signed in        -> /login
 *   - signed in + has plan  -> /app   (auto-continue, incl. right after purchase)
 */
const VerifiedPage = () => {
  const navigate = useNavigate();
  const { isLoaded, isSignedIn, has } = useAuth();
  const { session } = useSession();

  const hasPlan = isLoaded && isSignedIn && has &&
    (has({ plan: 'basic_subscription' }) || has({ plan: 'premium_subscription' }));

  useEffect(() => {
    if (!isLoaded) return;
    if (!isSignedIn) navigate('/login');
    else if (hasPlan) navigate('/app');
  }, [isLoaded, isSignedIn, hasPlan, navigate]);

  // While a just-purchased plan propagates into the session token, poll so the
  // redirect above fires as soon as the plan is active.
  useEffect(() => {
    if (isSignedIn && !hasPlan && session) {
      const timer = setInterval(() => session.reload(), 3000);
      return () => clearInterval(timer);
    }
  }, [isSignedIn, hasPlan, session]);

  // Only the "signed in, no plan" state renders here; the rest redirect above.
  if (!isLoaded || !isSignedIn || hasPlan) {
    return <div className="verified-page-container verified-centered" />;
  }

  return (
    <div className="verified-page-container">
      <div className="verified-pricing-header">
        <h1>VerDict AI</h1>
        <p>Start your free trial — no commitment, cancel anytime</p>
      </div>
      <div className="verified-pricing-wrapper">
        <PricingTable />
      </div>
      <Footer />
    </div>
  );
};

export default VerifiedPage;
